import type { CSSProperties } from 'react';

import { Flex, Text } from '@highlight-cp/core-ui';

import classes from './status-banner.module.css';

interface StatusBannerProps {
  /** Mantine palette family the bar takes its hue from, e.g. `yellow` — not a raw CSS colour. */
  color: string;
  icon: React.ReactNode;
  children: string;
}

/**
 * A full-width status bar tinted the same as the StatusBadge for that status — the palette's light
 * shade behind the default near-black text, so it stays legible on every hue. Icons inherit it.
 */
const StatusBanner = ({ color, icon, children }: StatusBannerProps) => (
  <Flex
    align="center"
    justify="center"
    gap="xs"
    px="lg"
    role="status"
    aria-live="polite"
    aria-atomic="true"
    className={classes.root}
    c="var(--mantine-color-text)"
    style={{ '--status-banner-bg': `var(--mantine-color-${color}-light-hover)` } as CSSProperties}
  >
    <Flex align="center" aria-hidden="true">
      {icon}
    </Flex>
    <Text fw={600}>{children}</Text>
  </Flex>
);

export default StatusBanner;
